import type { IPaymentState } from '../../types';

import type { AddPaymentMethodMode } from './types';

export const getPaymentValuesForMode = (
  paymentValues: IPaymentState,
  mode: AddPaymentMethodMode
): IPaymentState =>
  mode === 'vaulted'
    ? {
        ...paymentValues,
        saveCard: true,
      }
    : paymentValues;
